import { render, staticRenderFns } from "./flowContent.vue?vue&type=template&id=0899e31c&scoped=true"
import script from "./flowContent.vue?vue&type=script&lang=js"
export * from "./flowContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0899e31c",
  null
  
)

export default component.exports